/* eslint-disable @typescript-eslint/no-explicit-any */
import axiosInstance from "../../config/axiosConfig";

export const getFlowDashboard = async ({ queryKey }: any) => {
  return axiosInstance
    .post(`locationManagement/locationFlowView`, queryKey?.[1])
    .then((res) => res.data)
    .catch((err) => {
      throw err.data;
    });
};

export const getLocationDashboard = async ({ queryKey }: any) => {
  return axiosInstance
    .post(`locationManagement/locationViewTrack`, queryKey?.[1])
    .then((res) => res.data)
    .catch((err) => {
      throw err.data;
    });
};

export const getActivityLog = async ({ queryKey }: any) => {
  const payload = queryKey?.[1]?.payload;
  const url = queryKey?.[1]?.url;

  return axiosInstance
    .post(`locationManagement/${url}`, payload)
    .then((res) => res.data)
    .catch((err) => {
      throw err.data;
    });
};

export const downloadLocationView = async ({ payload, url }: any) => {
  return axiosInstance
    .post(`locationManagement/${url}`, payload)
    .then((res) => res.data)
    .catch((err) => {
      throw err.data;
    });
};

export const getSecondaryLocations = async (payload: any) => {
  return axiosInstance
    .post(`/locationManagement/getAllSecondaryLocation`, payload)
    .then((res) => res.data)
    .catch((err) => {
      throw err.data;
    });
};
